import { Component, Input, input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { MyBetsBet, MyBetsBetSlip, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsTextBadgeModel } from '../badges/my-bets-text-badge.component';

@Component({
    selector: 'ms-my-bets-single-bet-card',
    templateUrl: 'my-bets-single-bet-card.html',
    standalone: false,
})
export class MyBetsSingleBetCardComponent {
    @Input({ required: true }) betslip: MyBetsBetSlip;
    @Input() myBetsListContext: MyBetsListContext;
    mybetsTextBadgeModel = MyBetsTextBadgeModel;
    isEpMarket = true;
    cashedOut = input(false);
    cancelledBet = input(false);

    constructor(public sitecore: Sitecore) {}

    get bet(): MyBetsBet {
        return this.betslip.bets[0];
    }

    get isCashoutMessageVisible(): boolean {
        return this.betslip.isRecoveringAfterEditBet;
    }
}
